// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BtnOPtionsMessage_ekkWs {
    display: flex;
    align-items: center;
    gap: 10px;
  button {
    background-color: transparent;
    outline: none;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    outline: none;
    border: none;
    position: relative;
    border: 1px solid #00000036;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    min-width: 30px;
    height: 30px;
    font-weight: 500;
    &:hover{
      svg{
        fill: var(--_10a37f-background);
        color: var(--_10a37f-background);
      }
    }
    svg{
      height: 18px;
      width: 18px;
      fill: var(--_2-color);
      color: var(--_2-color);
    }
    .pinnedIconSvg_cQryT{
      fill: var(--_10a37f-background);
      color: var(--_10a37f-background);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/BtnOptionsMessage/BtnOPtionsMessage.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB;MACE;QACE,+BAA+B;QAC/B,gCAAgC;MAClC;IACF;IACA;MACE,YAAY;MACZ,WAAW;MACX,qBAAqB;MACrB,sBAAsB;IACxB;IACA;MACE,+BAA+B;MAC/B,gCAAgC;IAClC;EACF;AACF","sourcesContent":[".BtnOPtionsMessage {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  button {\n    background-color: transparent;\n    outline: none;\n    border: none;\n    cursor: pointer;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    outline: none;\n    border: none;\n    position: relative;\n    border: 1px solid #00000036;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    min-width: 30px;\n    height: 30px;\n    font-weight: 500;\n    &:hover{\n      svg{\n        fill: var(--_10a37f-background);\n        color: var(--_10a37f-background);\n      }\n    }\n    svg{\n      height: 18px;\n      width: 18px;\n      fill: var(--_2-color);\n      color: var(--_2-color);\n    }\n    .pinnedIconSvg{\n      fill: var(--_10a37f-background);\n      color: var(--_10a37f-background);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BtnOPtionsMessage": `BtnOPtionsMessage_ekkWs`,
	"pinnedIconSvg": `pinnedIconSvg_cQryT`
};
export default ___CSS_LOADER_EXPORT___;
